import { render, staticRenderFns } from "./ProductFiltersSeed.vue?vue&type=template&id=07133526&lang=html&"
import script from "./ProductFiltersSeed.vue?vue&type=script&lang=js&"
export * from "./ProductFiltersSeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports